var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpace2Swirl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1982.25 382.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        mix-blend-mode: screen;\n        opacity: .3;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-3);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 992.8,
    cy: 251.54,
    fx: 992.8,
    fy: 251.54,
    r: 740.98,
    gradientTransform: "translate(0 75.62) scale(1 .47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f3669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31144f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cy: 413.81,
    fy: 413.81,
    r: 719.64,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 989.45,
    cy: 34.97,
    fx: 989.45,
    fy: 34.97,
    r: 713.2,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1982.25,31.6c-32.39,12.13-93.28,35.2-162.6,62.79-102.9,40.96-226.91-4.96-398.42-18.62-171.5-13.65-313.98,76.95-506.6,119.15-192.61,42.2-385.23-68.26-649.08-59.57-110.81,3.65-197.88,28.97-262.2,57.21v128.51c86.74-37.92,214.87-87.13,301.78-90.15,142.48-4.96,258.58,125.35,601.58,125.35s353.56-198.58,496.04-210.99c142.48-12.41,248.02,137.28,404.34,137.28,94.49,0,147.77-41.54,175.15-69.02V31.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1807.11,296.21c-156.32,0-261.86-149.69-404.34-137.28-142.48,12.41-153.03,210.99-496.04,210.99s-459.1-130.32-601.58-125.35c-86.91,3.03-215.04,52.23-301.78,90.15v12.41c86.74-37.92,214.87-87.13,301.78-90.15,142.48-4.96,258.58,125.35,601.58,125.35s353.56-198.58,496.04-210.99c142.48-12.41,248.02,137.28,404.34,137.28,94.49,0,147.77-41.54,175.15-69.02v-12.41c-27.37,27.48-80.65,69.02-175.15,69.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1816.3,62.79c-102.9,40.96-226.91-4.96-398.42-18.62-171.5-13.65-313.98,76.95-506.6,119.15-192.61,42.2-385.23-68.26-649.08-59.57-110.81,3.65-197.88,28.97-262.2,57.21v11.17c64.32-28.24,151.39-53.56,262.2-57.21,263.85-8.69,456.47,101.77,649.08,59.57,192.61-42.2,335.09-132.8,506.6-119.15,171.5,13.65,295.52,59.57,398.42,18.62,69.32-27.59,130.21-50.66,162.6-62.79V0c-32.39,12.13-93.28,35.2-162.6,62.79Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpace2Swirl);
export default __webpack_public_path__ + "static/media/SPACE2_SWIRL.ec41e669ac4bf35821cca59fedc33d32.svg";
export { ForwardRef as ReactComponent };